import { showApiErrorSnackbar, showApiSuccessSnackbar } from '@/shared/helpers/thunk';
import { t } from '@/core/localization';
import { createAppAsyncThunk } from '@/warehouse/helpers';
import { stocksApi } from '@/warehouse/modules/stocks/business';
import { stocksActions } from '../stocks.state';
// TODO: to delete all redundant comments later
// TODO: (duplicated with the same thunk in Admin app). Try to use the single instance?
const relocateStockItem = createAppAsyncThunk('stocks/relocateStockItem', async (stockItemRelocate, { dispatch, rejectWithValue, fulfillWithValue }) => {
    dispatch(stocksActions.setRelocateErrorResponse(undefined));
    try {
        // TODO: later remove result handling, when new backend is done.
        const result = await dispatch(stocksApi.endpoints.relocateStockItem.initiate(stockItemRelocate)).unwrap();
        if (result.success) {
            dispatch(showApiSuccessSnackbar(t('stock.cell.balance.item.relocated.successfully')));
            // resetAndClose(true);
            fulfillWithValue(true);
        }
        else {
            dispatch(stocksActions.setRelocateErrorResponse({ status: 200, data: { error: result.error } }));
            rejectWithValue(result.error);
        }
    }
    catch (error) {
        dispatch(showApiErrorSnackbar({ header: t('stock.cell.balance.item.relocate.failed'), error }));
        console.error('Stock item relocate failed.', error);
        if (error instanceof Error) {
            return rejectWithValue(`Cannot relocate stock item, error: ${error.message}`);
        }
        return rejectWithValue('Server unexpected error');
    }
    finally {
        // TODO: to delete comments
        // `setTimeout` is used since table is too big to rerender fast, and price list still exists some time after delete request
        // has been finished.
        // setTimeout(() => dispatch(priceListActions.removeItemFromBeingDeleted(priceListId)), 3000);
        // dispatch(stockActions.setBeingUpdatedCellId({ cellId: undefined }));
    }
});
export { relocateStockItem };
